module.exports = __webpack_public_path__ + "start.svg";